import PropTypes from "prop-types";
import { ModeSelector } from "./ModeSelector";

export function MobileHeader({ title, action, children }) {
    return (
        <div className="flex flex-col gap-4 mb-6 md:hidden">
            <div className="flex items-center justify-between">
                <h1 className="text-2xl font-bold">{title}</h1>
                {action && <div>{action}</div>}
            </div>
            {/* Mode Selector visible only on mobile here */}
            <div className="w-full">
                <ModeSelector />
            </div>
            {children}
        </div>
    );
}

MobileHeader.propTypes = {
    title: PropTypes.string.isRequired,
    action: PropTypes.node,
    children: PropTypes.node
};
